import React, { useCallback } from 'react';

import { SxProps } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';

import { TabData } from '@ts-core/core/hooks/ui';

export interface NavigationTabBarProps {
  sx?: SxProps;

  tabs: TabData[];
  activeTab?: TabData;
  onGoToTab: (tabSlug: string) => void;
}

const NavigationTabBar = (props: NavigationTabBarProps) => {
  const { sx, tabs, activeTab, onGoToTab } = props;

  const handleChangeTab = useCallback(
    (event: any, newValue: string) => {
      onGoToTab(newValue);
    },
    [onGoToTab]
  );

  return (
    <Box borderBottom={1} borderTop={1} sx={sx}>
      {activeTab && (
        <Tabs value={activeTab?.slug} centered onChange={handleChangeTab}>
          {tabs.map((tab) => (
            <Tab key={tab.slug} value={tab.slug} label={tab.label} />
          ))}
        </Tabs>
      )}
    </Box>
  );
};

export default NavigationTabBar;
